export default __webpack_public_path__ + "static/media/forestly-expl-dissect-05_DE.f8727665.png";